import gql from 'graphql-tag'

export default gql`
mutation ($_id: MongoID!   ){
    removeStudentUser(_id:$_id){
        recordId
      }
}
`
